import { PaperBox } from "../../../../../components/Layout/PaperBox"
import { IDetalhePublicoTitulosReceber } from "../../../../../types/api/cadastros/detalhar-publico";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import { DadoValorPrinter } from "../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { Box, Link } from "@mui/material";
import { useState } from "react";
import DialogDetalhe from "./DialogDetalhe";

export const CardTitulosReceber = ({
    data
}: CardTitulosReceberProps) => {

    const [openDetalhe, setOpenDetalhe] = useState<boolean>(false)

    return (
        <>
            <PaperBox title="Títulos a receber" height={'100%'}>
                <Box display={'flex'} gap={2} flexWrap={'wrap'} justifyContent={'space-between'}>
                    <DadoValorPrinter titulo="Valor títulos a vencer" valor={`${formatarValorMonetario(data.titulos_a_vencer_total)}`} alignValue="right" />
                    <DadoValorPrinter titulo="Valor títulos vencidos" valor={`${formatarValorMonetario(data.titulos_vencidos_total)}`} alignValue="right" />
                    <DadoValorPrinter titulo="Valor trocas a vencer" valor={`${data.titulo_trocas_sacas} SACAS - ${formatarValorMonetario(data.titulo_trocas_total)}`} alignValue="right" />
                    <DadoValorPrinter titulo="Valor total" valor={`${formatarValorMonetario(data.titulos_total)}`} alignValue="right" alignTitle="right" />
                </Box>
                <Box display={'flex'} justifyContent={'flex-end'}>
                    {
                        data.titulos &&
                        <Link mt={1} onClick={() => setOpenDetalhe(true)} sx={{ cursor: 'pointer' }}>Ver detalhes</Link>
                    }
                </Box>
            </PaperBox>
            {
                openDetalhe && 
                <DialogDetalhe
                    {...{ data }}
                    open={openDetalhe}
                    handleClose={() => setOpenDetalhe(false)}
                />
            }
        </>
    )
}

interface CardTitulosReceberProps {
    data: IDetalhePublicoTitulosReceber
}
